import React from "react";

import "./style.scss";

export enum VisualHeadlineSize {
    EXTRA_LARGE = "xl",
    LARGE = "l",
    MEDIUM = "m",
    REGULAR = "r",
    SMALL = "s",
    EXTRA_SMALL = "xs"
}

export type SemanticHeadlineSize = 0 | 1 | 2 | 3 | 4 | 5 | 6;

const sizeMap: { [key in VisualHeadlineSize]: SemanticHeadlineSize } = {
    [VisualHeadlineSize.EXTRA_LARGE]: 1,
    [VisualHeadlineSize.LARGE]: 1,
    [VisualHeadlineSize.MEDIUM]: 2,
    [VisualHeadlineSize.REGULAR]: 3,
    [VisualHeadlineSize.SMALL]: 3,
    [VisualHeadlineSize.EXTRA_SMALL]: 4
};

interface Props {
    visualSize?: VisualHeadlineSize;
    semanticSize?: SemanticHeadlineSize;
    children: React.ReactNode;
    className?: string;

    [key: string]: any;
}

/**
 * This renders a headline (h1 - h6) with the correct visual size.
 * If needed, the visual size can differ from the actual semantic size.
 * Per default, you only need to give a visual size and the semantic size will be determined automatically.
 */
export function Headline({
                             semanticSize,
                             visualSize = VisualHeadlineSize.MEDIUM,
                             children,
                             className,
                             ...props
                         }: Props) {
    const classNames = ["h"];
    let usedVisualSize: string | undefined = visualSize;

    if (semanticSize === undefined) {
        semanticSize = sizeMap[visualSize];
    }

    if (usedVisualSize) {
        classNames.push(usedVisualSize);
    }

    if (className) {
        classNames.push(className);
    }

    const tagName = semanticSize
        ? `h${semanticSize}`
        : "strong";

    return React.createElement(tagName, { ...props, className: classNames.join(" ") }, children);
}
